import { trackRemoveFromCart } from '../../../../../../shared/analytics/e-commerce/trackRemoveFromCart';
import { flatten } from '../../../../../../shared/utils/flatten';
import { IAncillary } from '../../../../../domain/ancillary/domain/models/IAncillary';
import { adaptAncillaryToItems } from './adapters/adaptAncillaryToItems';

export function trackRemoveAncillaries(ancillaries: IAncillary[]) {
	const nestedItems = ancillaries.map(adaptAncillaryToItems);

	trackRemoveFromCart({
		items: flatten(nestedItems),
	});
}
